import React from 'react';
import classNames from 'classnames';

import { Tooltip } from '../../scripts/components/moderation-v2/sharable/components/Tooltip';
import { CircleInfoIcon } from '../../scripts/icons';

import styles from './InfoCircle.module.scss';

export interface InfoCircleProps {
  tooltip: string;
  iconClassName?: string;
  containerClassName?: string;
}

export const InfoCircle = (props: InfoCircleProps) => {
  const { tooltip, iconClassName, containerClassName } = props;

  return (
    <Tooltip title={tooltip}>
      <div className={containerClassName}>
        <CircleInfoIcon className={classNames(styles.icon, iconClassName)} />
      </div>
    </Tooltip>
  );
};
